import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import { Greeting } from 'components/custom';
import { useIsOidcUser, useIsUntisUser } from 'components/kratos';
import { useOutletContext } from 'react-router-dom';
import { formatUserName } from 'utils/session';
import { setTitle } from 'utils/head';
import Timetable from './Timetable';
const Home = () => {
    const { t } = useTranslation('home');
    const { user } = useOutletContext();
    const [userFullName, setUserFullName] = useState('');
    // Check if user authenticated via OIDC (SSO)
    const isOidcUser = useIsOidcUser();
    const isUntisUser = useIsUntisUser();
    useEffect(() => {
        setTitle(t('head.title'));
        /*
         * For generic OIDC users: hide name (only sub available, no real name)
         * For Untis OIDC users: show name (resolved from OneRoster API)
         * For normal users: show name
         */
        setUserFullName(isOidcUser && !isUntisUser ? '' : formatUserName(user));
    }, [t, user, isOidcUser, isUntisUser]);
    return (_jsxs(Stack, { spacing: 2, children: [_jsx(Greeting, { translationNamespace: "home", name: userFullName }), _jsx(Timetable, {})] }));
};
export default Home;
